<template>
  <b-form-row>
    <b-col>
      <b-form-group label="Articulo">
        <multiselect
          v-model="TipoLicencia"
          id="msArticulo"
          label="Articulo"
          track-by="Id"
          placeholder="Haga click para buscar"
          open-direction="bottom"
          :max-height="900"
          :custom-label="labelTipoLicencia"
          :options="arregloArticulos"
          :searchable="true"
          :clear-on-select="false"
          :close-on-select="true"
          :show-no-results="false"
          :disabled="disabled"
          @select="tipoLicenciaChange"

          selectLabel="Enter para seleccionar"
          selectedLabel="Seleccionado"
          deselectLabel="Enter para remover"
          noOptions="Sin resultados"
          :allow-empty="true"
        >
          <span slot="noResult">Oops! No se encontraron resultados.</span>
        </multiselect>
      </b-form-group>
    </b-col>
    <b-col>
      <b-form-group id="grupoInstancia" label="Instancia :" label-for="selectInstancia">
        <multiselect
          id="msInstancia"
          v-model="DetalleDiasLicencia"
          track-by="Id"
          label="Descripcion"
          placeholder="--Seleccionar--"
          :options="arrDetalleDiasLicencia"
          :searchable="true"
          :allow-empty="false"
          :max-height="150"
          :disabled="disabled"
          >
          <template slot="singleLabel" slot-scope="{ option }">
            <strong>{{ option.Descripcion }}</strong>
          </template>
          <span slot="noResult">Oops! No se encontraron resultados.</span>
        </multiselect>
      </b-form-group>
    </b-col>
  </b-form-row>
</template>

<script>
import Multiselect from "vue-multiselect";
import TipoLicenciaSvc from "@/services/tipolicencia";
import DetalleDiasLicenciaSvc from "@/services/detallediaslicencia";
import { mapGetters, mapActions } from "vuex";
import { createHelpers } from 'vuex-map-fields';

const { mapFields: mapLicenciaFields } = createHelpers({
  getterType: 'FormLicenciaModule/getLicenciaField',
  mutationType: 'FormLicenciaModule/updateLicenciaField',
});

export default {
  components: { Multiselect },
  name: "TipoLicenciaSelect",
  computed: {
    ...mapGetters([
      "getUserInfo","isInRoleEstablecimiento"
    ]),
    ...mapLicenciaFields(['TipoLicencia', 'TipoLicencia_Id', 'DetalleDiasLicencia']),
  },
  data() {
    return {
      disabled: null,
      articuloSelected: [],
      arrDetalleDiasLicencia: [],
      arregloArticulos: [],
      instanciaSeleccionada: {},
      rolUsuario: ""
    }
  },
  methods: {
    reset(){
      this.DetalleDiasLicencia = null;
      this.TipoLicencia = null;
      this.TipoLicencia_Id = null;
    },
    labelTipoLicencia({ Regimen, Articulo, Descripcion }) {
      return `${Regimen} – ${Articulo} - ${Descripcion}`;
    },
    obtenerDetalles(id) {
      console.log('obtenerDetalles', id);
      this.arrDetalleDiasLicencia = [];
      this.DetalleDiasLicencia = null;
      DetalleDiasLicenciaSvc.getLista({
        tipolicencia_id : id
      }).then(response => {
          this.arrDetalleDiasLicencia = [];
          response.data.rows.forEach(element => {
            this.arrDetalleDiasLicencia.push(element);
          });
        })
        .catch(e => {
          console.log("Error: " + e);
        });
    },
    getSelectTipoLicencia() {
      console.log('getSelectTipoLicencia', this.TipoLicencia_Id);

      TipoLicenciaSvc.getLista({
        limit: 500,
        //sector: this.getUserInfo.Roles.length === 1 && this.isInRoleEstablecimiento ? "establecimiento" : ""
      })
      .then(r => {
        this.arregloArticulos = r.data.rows;
        this.TipoLicencia = null;
        this.DetalleDiasLicencia = null;
        if(this.TipoLicencia_Id && this.TipoLicencia_Id !== -1){
          this.TipoLicencia = this.arregloArticulos.find(option => option.Id === this.TipoLicencia_Id);
          console.log('this.TipoLicencia', this.TipoLicencia,  this.TipoLicencia_Id);
          this.tipoLicenciaChange(this.TipoLicencia);
          this.arregloArticulos.forEach(t => {
            if(this.TipoLicencia_Id !== t.Id){
              t.$isDisabled= true;
            }
            if(this.TipoLicencia_Id === 31){
              if(t.Id == 31 || t.Id == 32 || t.Id === 33){
                t.$isDisabled= false;
              }
            } 
          });
        }else{
          this.arregloArticulos.forEach(t => {
            console.log('TipoLicencia t.Id', t.Id, this.TipoLicencia,  this.TipoLicencia_Id);
            if((t.Id === 13 || t.Id === 35 || t.Id === 37 || t.Id === 38 || t.Id === 85) && this.TipoLicencia_Id !== -1){
              t.$isDisabled= true;
            }
          });
        }
      })
      .catch(e => {
        //this.errorHandler(e);
        alert('ERROR TipoLicencia ' + e);
        console.log('ERROR TipoLicencia ', e);
      });
    },
    tipoLicenciaChange(articulo) {
      if(articulo){
        this.obtenerDetalles(articulo.Id);
      }
    },
  },
  created() {
    this.getSelectTipoLicencia();
  }
};
</script>





// WEBPACK FOOTER //
// src/components/common/TipoLicenciaSelect.vue